import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {RouterContextDirective} from '@core/directives/router-context.directive';
import {CommentsIconComponent} from '@core/svg-icons/comments-icon.component';
import {StoreConfigService} from '@core/services/store-config.service';
import {DecimalPipe} from '@angular/common';
import {environment} from '@env/environment';
import {CountrySelectorComponent} from '../../../../atoms/country-selector/country-selector.component';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, FontAwesomeModule, RouterContextDirective, CommentsIconComponent, DecimalPipe, CountrySelectorComponent]
})
export class HeaderTopComponent {
  showOnDk = environment.locale === 'da-DK';
  showB2B = environment.supervin.showB2B;
  private storeConfigService = inject(StoreConfigService);

  freeDeliveryStartsFrom = computed(() => {
    return this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom;
  });

  minimumFreightPrice = computed(() => {
    return this.storeConfigService.storeConfig()?.minimumFreightPrice;
  });

}
